import React from 'react';
import { HiddenCityData } from '@kiwicom/openapi-sdk/mmb';
import SmartFaqLink, { articleIds } from '@kiwicom/overlord/src/components/SmartFaqLink';

import ItineraryBadgeList from '../ItineraryBadgeList';
import ItinerarySegmentBannerWithRef from './ItinerarySegmentBannerWithRef';

type HiddenCityBannerProps = {
  hiddenCityData: HiddenCityData;
};

/**
 * Component which renders a ItinerarySegmentBanner containing a list of badges connected to the THC segment info.
 * After clicking on the banner, the SFAQ article about THC is opened.
 * @param hiddenCityData - information about hidden part of the segment (containing list of badges)
 *
 * @returns HiddenCityBanner component
 */
const HiddenCityBanner = ({ hiddenCityData }: HiddenCityBannerProps) => {
  return (
    <SmartFaqLink articleId={272 as articleIds} legacyBehavior>
      <ItinerarySegmentBannerWithRef>
        <ItineraryBadgeList badges={hiddenCityData.badges} spaceAfter="none" spacing="200" />
      </ItinerarySegmentBannerWithRef>
    </SmartFaqLink>
  );
};
export default HiddenCityBanner;
